var _excluded = ["variant", "backgroundColor", "isLoading", "header", "footer", "children", "paddingContent", "data-testid"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { Box } from '../../components/internal';
import { Fade, Loader } from '../../foundations';
import { useBreakpointValue } from '../../theme';
import { forwardRef, useTestId } from '../../utils';
import { useMultiStyleConfig } from '../../utils/use-style-config';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Layout = forwardRef((_ref, ref) => {
  var {
    variant,
    backgroundColor = 'default',
    isLoading,
    header,
    footer,
    children,
    paddingContent,
    'data-testid': dataTestId = 'layout'
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var columns = useBreakpointValue({
    xs: 4,
    s: 8,
    m: 8,
    l: 8,
    xl: 16
  });
  var styles = useMultiStyleConfig('Layout', {
    columns,
    variant,
    isLoading,
    backgroundColor,
    paddingContent
  });
  var getTestId = useTestId(dataTestId);

  var headerComponent = /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({
    __css: styles['header']
  }, getTestId('header')), {}, {
    children: header === null || header === void 0 ? void 0 : header.content
  }));

  var footerComponent = /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({
    __css: styles['footer']
  }, getTestId('footer')), {}, {
    children: footer === null || footer === void 0 ? void 0 : footer.content
  }));

  return /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread(_objectSpread({}, getTestId()), {}, {
    "data-component": "Layout",
    ref: ref
  }, props), {}, {
    __css: styles['container'],
    children: isLoading ? /*#__PURE__*/_jsx(Loader, _objectSpread({}, getTestId('loader'))) : /*#__PURE__*/_jsxs(Fade, {
      in: !isLoading,
      style: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%'
      },
      children: [(header === null || header === void 0 ? void 0 : header.isSticky) && headerComponent, /*#__PURE__*/_jsxs(Box, {
        __css: styles['content']
        /* Scrollable container should be accessible by keyboard */

        /* https://dequeuniversity.com/rules/axe/4.8/scrollable-region-focusable?application=axeAPI */
        ,
        tabIndex: 0,
        children: [header && !(header !== null && header !== void 0 && header.isSticky) && headerComponent, /*#__PURE__*/_jsx(Box, {
          __css: styles['grid'],
          children: /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({
            __css: styles['gridItem']
          }, getTestId('content')), {}, {
            children: children
          }))
        }), footer && !(footer !== null && footer !== void 0 && footer.isSticky) && footerComponent]
      }), (footer === null || footer === void 0 ? void 0 : footer.isSticky) && footerComponent]
    })
  }));
});
Layout.displayName = 'Layout';
//# sourceMappingURL=Layout.js.map